import React from 'react';
import StatsGrid from './StatsGrid';
import RecentActivity from './RecentActivity';
import Card from '../common/Card';

const HomeTab = ({ onNavigate }) => {
  return (
    <div className="home-tab">
      <Card>
        <h2 className="card-title">📊 Recruitment Dashboard</h2>
        <StatsGrid onNavigate={onNavigate} />
      </Card>
      <Card>
        <h2 className="card-title">📈 Recent Activity</h2>
        <RecentActivity />
      </Card>
    </div>
  );
};

export default HomeTab;